export const generatedAssumptionImpactLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-assumption-impact-ledger",
  "operatingRule": "Scenario recommendations must cite the assumptions that can move the ranking, their source coverage, uncertainty, stress behavior, and promotion gates.",
  "assumptionCount": 5,
  "blockedAssumptionCount": 3,
  "mostSensitiveAssumptions": [
    {
      "assumptionId": "assumption-resource-composition-unknown",
      "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
      "maxRankShift": 0,
      "maxUtilityDelta": 1.68,
      "reviewState": "blocked-for-business-proof"
    },
    {
      "assumptionId": "assumption-launch-cost-ranges",
      "title": "Launch economics must use dated ranges and sensitivity bands",
      "maxRankShift": 0,
      "maxUtilityDelta": 0.67,
      "reviewState": "blocked-for-business-proof"
    },
    {
      "assumptionId": "assumption-snapshot-first",
      "title": "Browser consumes reviewed snapshots first",
      "maxRankShift": 0,
      "maxUtilityDelta": 0.46,
      "reviewState": "reviewable"
    }
  ],
  "inputHashes": {
    "assumptions": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11",
    "scenarios": "sha256-e0d0a78ec49bf1456f7b884a37556bbea289f8740205e65d67dd3db12904089b",
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "defaultWeights": "sha256-5131a19946c87940b7042077430239d4ccf731cd2fe8966b65fa108782d2e6e9"
  },
  "assumptionImpacts": [
    {
      "assumptionId": "assumption-snapshot-first",
      "title": "Browser consumes reviewed snapshots first",
      "state": "validated-product-rule",
      "owner": "Science kernel",
      "uncertainty": "Low",
      "businessQuestion": "Would a live API/schema drift event change the scenario order without reviewed snapshots?",
      "affectedScenarioIds": [
        "hybrid",
        "moon-first",
        "asteroid-first",
        "mercury-orbit",
        "mercury-polar",
        "mars-first"
      ],
      "stressWeights": {
        "benefits": {
          "resourceConfidence": 1.06
        },
        "risks": {
          "feedstock": 1.12,
          "processMaturity": 1.08
        }
      },
      "sourceCoverage": {
        "sourceCount": 4,
        "missingSourceIds": [],
        "primarySourceCount": 4,
        "recordHashes": [
          "fnv1a32-9335c241",
          "fnv1a32-93c0fe91",
          "fnv1a32-ba0c45bb",
          "fnv1a32-97d74c96"
        ]
      },
      "scenarioImpacts": [
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baseRank": 2,
          "stressedRank": 2,
          "rankDelta": 0,
          "baseUtility": 65.69,
          "stressedUtility": 65.48,
          "utilityDelta": -0.21
        },
        {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "baseRank": 1,
          "stressedRank": 1,
          "rankDelta": 0,
          "baseUtility": 67.12,
          "stressedUtility": 67.01,
          "utilityDelta": -0.11
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baseRank": 3,
          "stressedRank": 3,
          "rankDelta": 0,
          "baseUtility": 51.37,
          "stressedUtility": 50.91,
          "utilityDelta": -0.46
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baseRank": 4,
          "stressedRank": 4,
          "rankDelta": 0,
          "baseUtility": 42.95,
          "stressedUtility": 42.91,
          "utilityDelta": -0.04
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baseRank": 6,
          "stressedRank": 6,
          "rankDelta": 0,
          "baseUtility": 37.95,
          "stressedUtility": 38.12,
          "utilityDelta": 0.17
        },
        {
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "baseRank": 5,
          "stressedRank": 5,
          "rankDelta": 0,
          "baseUtility": 40.78,
          "stressedUtility": 41.11,
          "utilityDelta": 0.33
        }
      ],
      "maxRankShift": 0,
      "maxUtilityDelta": 0.46,
      "stressedWinner": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 67.01
      },
      "stressedUncertainty": {
        "iterations": 128,
        "seed": "assumption-snapshot-first-stress",
        "winner": "moon-first",
        "highestWinProbability": 70.31
      },
      "reviewGate": {
        "promotionAllowed": true,
        "state": "reviewable",
        "requiredEvidence": "All displayed science claims must resolve to local source records or reviewed artifacts.",
        "riskIfWrong": "Live API outages or schema changes could make the beta unreproducible."
      },
      "impactHash": "sha256-18d17b3a43121dce702111672030500b3f2312262307f39aadb9177aeff29eb8"
    },
    {
      "assumptionId": "assumption-no-mercury-first",
      "title": "Mercury cannot be hardcoded as the winning scenario",
      "state": "validated-product-rule",
      "owner": "Scenario engine",
      "uncertainty": "Low",
      "businessQuestion": "Can conservative transport, thermal, communications, and maturity assumptions make Moon-first win?",
      "affectedScenarioIds": [
        "hybrid",
        "moon-first",
        "mercury-orbit",
        "mercury-polar"
      ],
      "stressWeights": {
        "risks": {
          "transport": 1.22,
          "thermal": 1.18,
          "comms": 1.15,
          "processMaturity": 1.1
        }
      },
      "sourceCoverage": {
        "sourceCount": 3,
        "missingSourceIds": [],
        "primarySourceCount": 3,
        "recordHashes": [
          "fnv1a32-9335c241",
          "fnv1a32-7c477cc2",
          "fnv1a32-78229f8d"
        ]
      },
      "scenarioImpacts": [
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baseRank": 2,
          "stressedRank": 2,
          "rankDelta": 0,
          "baseUtility": 65.69,
          "stressedUtility": 65.85,
          "utilityDelta": 0.16
        },
        {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "baseRank": 1,
          "stressedRank": 1,
          "rankDelta": 0,
          "baseUtility": 67.12,
          "stressedUtility": 67.32,
          "utilityDelta": 0.2
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baseRank": 4,
          "stressedRank": 4,
          "rankDelta": 0,
          "baseUtility": 42.95,
          "stressedUtility": 42.67,
          "utilityDelta": -0.28
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baseRank": 6,
          "stressedRank": 6,
          "rankDelta": 0,
          "baseUtility": 37.95,
          "stressedUtility": 37.5,
          "utilityDelta": -0.45
        }
      ],
      "maxRankShift": 0,
      "maxUtilityDelta": 0.45,
      "stressedWinner": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 67.32
      },
      "stressedUncertainty": {
        "iterations": 128,
        "seed": "assumption-no-mercury-first-stress",
        "winner": "moon-first",
        "highestWinProbability": 76.56
      },
      "reviewGate": {
        "promotionAllowed": true,
        "state": "reviewable",
        "requiredEvidence": "Conservative weights must allow Moon-first or other scenarios to outrank Mercury.",
        "riskIfWrong": "The product becomes advocacy rather than feasibility intelligence."
      },
      "impactHash": "sha256-af29cde19803c251fdb159311a364c052dcab8378ad33efccbe4fa6641075228"
    },
    {
      "assumptionId": "assumption-resource-composition-unknown",
      "title": "Asteroid/Mercury resource composition remains unknown until directly sourced",
      "state": "blocked-until-source-backed",
      "owner": "Resource ledger",
      "uncertainty": "High",
      "businessQuestion": "Which resource-dependent scenarios degrade when composition evidence is held at unknown?",
      "affectedScenarioIds": [
        "hybrid",
        "asteroid-first",
        "mercury-orbit",
        "mercury-polar"
      ],
      "stressWeights": {
        "benefits": {
          "resourceConfidence": 1.25,
          "optionality": 0.92
        },
        "risks": {
          "feedstock": 1.35
        }
      },
      "sourceCoverage": {
        "sourceCount": 3,
        "missingSourceIds": [],
        "primarySourceCount": 3,
        "recordHashes": [
          "fnv1a32-7c477cc2",
          "fnv1a32-93c0fe91",
          "fnv1a32-ba0c45bb"
        ]
      },
      "scenarioImpacts": [
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baseRank": 2,
          "stressedRank": 2,
          "rankDelta": 0,
          "baseUtility": 65.69,
          "stressedUtility": 64.83,
          "utilityDelta": -0.86
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baseRank": 3,
          "stressedRank": 3,
          "rankDelta": 0,
          "baseUtility": 51.37,
          "stressedUtility": 49.69,
          "utilityDelta": -1.68
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baseRank": 4,
          "stressedRank": 4,
          "rankDelta": 0,
          "baseUtility": 42.95,
          "stressedUtility": 42.13,
          "utilityDelta": -0.82
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baseRank": 6,
          "stressedRank": 6,
          "rankDelta": 0,
          "baseUtility": 37.95,
          "stressedUtility": 37.91,
          "utilityDelta": -0.04
        }
      ],
      "maxRankShift": 0,
      "maxUtilityDelta": 1.68,
      "stressedWinner": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 66.89
      },
      "stressedUncertainty": {
        "iterations": 128,
        "seed": "assumption-resource-composition-unknown-stress",
        "winner": "moon-first",
        "highestWinProbability": 83.59
      },
      "reviewGate": {
        "promotionAllowed": false,
        "state": "blocked-for-business-proof",
        "requiredEvidence": "Taxonomy, spectra, or mission data required before promotion.",
        "riskIfWrong": "Candidate feedstock rankings could imply unavailable or unmeasured materials."
      },
      "impactHash": "sha256-6d5911577e95f4f378f9c3b42381e039f24031c5391857cc77eb0fc0e1658c49"
    },
    {
      "assumptionId": "assumption-social-signals-market-only",
      "title": "Forums and social platforms are market signals, not science evidence",
      "state": "approved-governance-rule",
      "owner": "Product strategy",
      "uncertainty": "Low",
      "businessQuestion": "Does market interest alter diligence priority without promoting a science or engineering claim?",
      "affectedScenarioIds": [
        "hybrid",
        "moon-first",
        "asteroid-first",
        "mercury-orbit",
        "mercury-polar",
        "mars-first"
      ],
      "stressWeights": {
        "benefits": {
          "optionality": 0.95
        },
        "risks": {
          "processMaturity": 1.04
        }
      },
      "sourceCoverage": {
        "sourceCount": 0,
        "missingSourceIds": [],
        "primarySourceCount": 0,
        "recordHashes": []
      },
      "scenarioImpacts": [
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baseRank": 2,
          "stressedRank": 2,
          "rankDelta": 0,
          "baseUtility": 65.69,
          "stressedUtility": 65.62,
          "utilityDelta": -0.07
        },
        {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "baseRank": 1,
          "stressedRank": 1,
          "rankDelta": 0,
          "baseUtility": 67.12,
          "stressedUtility": 67.04,
          "utilityDelta": -0.08
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baseRank": 3,
          "stressedRank": 3,
          "rankDelta": 0,
          "baseUtility": 51.37,
          "stressedUtility": 51.28,
          "utilityDelta": -0.09
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baseRank": 4,
          "stressedRank": 4,
          "rankDelta": 0,
          "baseUtility": 42.95,
          "stressedUtility": 42.98,
          "utilityDelta": 0.03
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baseRank": 6,
          "stressedRank": 6,
          "rankDelta": 0,
          "baseUtility": 37.95,
          "stressedUtility": 37.98,
          "utilityDelta": 0.03
        },
        {
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "baseRank": 5,
          "stressedRank": 5,
          "rankDelta": 0,
          "baseUtility": 40.78,
          "stressedUtility": 40.72,
          "utilityDelta": -0.06
        }
      ],
      "maxRankShift": 0,
      "maxUtilityDelta": 0.09,
      "stressedWinner": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 67.04
      },
      "stressedUncertainty": {
        "iterations": 128,
        "seed": "assumption-social-signals-market-only-stress",
        "winner": "moon-first",
        "highestWinProbability": 68.75
      },
      "reviewGate": {
        "promotionAllowed": false,
        "state": "blocked-for-business-proof",
        "requiredEvidence": "Social-source records cannot promote claims without a primary-source bridge.",
        "riskIfWrong": "Unverified narratives could contaminate verified claim states."
      },
      "impactHash": "sha256-debdf52af9c609f7587809b69b32742d46d4550f56dbdecfae2dc25a5571fdad"
    },
    {
      "assumptionId": "assumption-launch-cost-ranges",
      "title": "Launch economics must use dated ranges and sensitivity bands",
      "state": "hypothesis",
      "owner": "Economics module",
      "uncertainty": "High",
      "businessQuestion": "Which scenario rankings are most sensitive to dated launch-cost and mass-to-site assumptions?",
      "affectedScenarioIds": [
        "hybrid",
        "moon-first",
        "asteroid-first",
        "mercury-orbit",
        "mercury-polar",
        "mars-first"
      ],
      "stressWeights": {
        "benefits": {
          "resourceConfidence": 1.08
        },
        "risks": {
          "transport": 1.35,
          "processMaturity": 1.08
        }
      },
      "sourceCoverage": {
        "sourceCount": 0,
        "missingSourceIds": [],
        "primarySourceCount": 0,
        "recordHashes": []
      },
      "scenarioImpacts": [
        {
          "scenarioId": "hybrid",
          "name": "Hybrid Moon -> Asteroid -> Mercury",
          "baseRank": 2,
          "stressedRank": 2,
          "rankDelta": 0,
          "baseUtility": 65.69,
          "stressedUtility": 65.62,
          "utilityDelta": -0.07
        },
        {
          "scenarioId": "moon-first",
          "name": "Moon-first Bootstrap",
          "baseRank": 1,
          "stressedRank": 1,
          "rankDelta": 0,
          "baseUtility": 67.12,
          "stressedUtility": 67.56,
          "utilityDelta": 0.44
        },
        {
          "scenarioId": "asteroid-first",
          "name": "Asteroid Feedstock-first",
          "baseRank": 3,
          "stressedRank": 3,
          "rankDelta": 0,
          "baseUtility": 51.37,
          "stressedUtility": 50.98,
          "utilityDelta": -0.39
        },
        {
          "scenarioId": "mercury-orbit",
          "name": "Mercury Orbit-first",
          "baseRank": 4,
          "stressedRank": 4,
          "rankDelta": 0,
          "baseUtility": 42.95,
          "stressedUtility": 42.28,
          "utilityDelta": -0.67
        },
        {
          "scenarioId": "mercury-polar",
          "name": "Mercury Polar Surface-first",
          "baseRank": 6,
          "stressedRank": 6,
          "rankDelta": 0,
          "baseUtility": 37.95,
          "stressedUtility": 37.32,
          "utilityDelta": -0.63
        },
        {
          "scenarioId": "mars-first",
          "name": "Mars-first Conventional Expansion",
          "baseRank": 5,
          "stressedRank": 5,
          "rankDelta": 0,
          "baseUtility": 40.78,
          "stressedUtility": 40.73,
          "utilityDelta": -0.05
        }
      ],
      "maxRankShift": 0,
      "maxUtilityDelta": 0.67,
      "stressedWinner": {
        "scenarioId": "moon-first",
        "name": "Moon-first Bootstrap",
        "utility": 67.56
      },
      "stressedUncertainty": {
        "iterations": 128,
        "seed": "assumption-launch-cost-ranges-stress",
        "winner": "moon-first",
        "highestWinProbability": 79.69
      },
      "reviewGate": {
        "promotionAllowed": false,
        "state": "blocked-for-business-proof",
        "requiredEvidence": "Every economics run needs source date, mass class, destination, margin, and sensitivity.",
        "riskIfWrong": "Scenario rankings could swing materially on stale or optimistic transport costs."
      },
      "impactHash": "sha256-4f535d33727617984ce47c8117d7e5b03da271ddd6a54e14c07b7a083a7675b3"
    }
  ],
  "ledgerHash": "sha256-7e2ab79096a0b3d5feb1133e5b4ed52de40cfb5514b14423ab0bb85be208af00"
}
;
